import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import HeadlineCTASection from '@/pages/home/components/HeadlineCTASection';
import DailyContestSection from '@/pages/home/components/DailyContestSection';
import HotGossipSection from '@/pages/home/components/HotGossipSection';
import PlatformStatsSection from '@/pages/home/components/PlatformStatsSection';
import UserReviewsSection from '@/pages/home/components/UserReviewsSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HeadlineCTASection />
        <DailyContestSection />
        <HotGossipSection />
        <PlatformStatsSection />
        <UserReviewsSection />
      </main>
      <Footer />
    </>
  );
}